export type LocalizedText = Record<string, string>

export const emptyLocalizedText = (): LocalizedText => ({
  zh: '',
  en: '',
})

export const normalizeLocalizedText = (
  value: LocalizedText | string | null | undefined
): LocalizedText => {
  if (!value) {
    return emptyLocalizedText()
  }

  if (typeof value === 'string') {
    return {
      zh: value,
      en: '',
    }
  }

  return {
    ...value,
    zh: value.zh || '',
    en: value.en || '',
  }
}

export const displayLocalizedText = (
  value: LocalizedText | string | null | undefined
): string => {
  if (!value) {
    return ''
  }

  if (typeof value === 'string') {
    return value
  }

  return value.zh || value['zh-Hant'] || value.en || ''
}
